export class ValidateEmailError extends Error {
  constructor(public error: string) {
    super(error);
  }
}
